import React from "react";
import PropTypes from "prop-types";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";
import { injectSheet } from "../../../_common/hocs";
import Tipografia from "../../../_common/components/Tipografia";
import { truncate } from "../../../_common/utils/commonCss";
import { PROVIDERS } from "../constantes";

const styles = {
  linkAnexoContainer: {
    width: 500,
    marginBottom: 10,
  },
  root: {
    backgroundColor: "#f2f2f2",
    height: 30,
    border: 1,
    borderStyle: "solid",
    borderColor: "#ccc",
    marginTop: 10,
    boxSizing: "border-box",
    paddingLeft: 10,
    paddingTop: 7,
  },
  textoAnexo: {
    ...truncate,
    fontWeight: "bold",
    fontFamily: "sans-serif !important",
    maxWidth: ({ modoTela }) => (modoTela ? 358 : 476),
  },
};

function ExibicaoAnexos({ classes, anexos, modoTela = true, somenteLeitura = false }) {
  const intl = useIntl();
  const provider = useSelector(state => state.emails.usuarioLogado.provider);

  if (provider.toUpperCase() !== PROVIDERS.Outlook) return null;

  const handleDownload = (base64Image, nome) => {
    const link = document.createElement("a");
    link.href = `data:application/octet-stream;base64,${base64Image}`;
    link.download = nome;
    link.click();
  };

  const getNomeAnexo = (nome, size) => {
    const sizeText = size ? ` (${(size / 1024).toFixed(0)}K)` : "";
    return `${nome}${sizeText}`;
  };

  return (
    <div className={classes.linkAnexoContainer}>
      <Tipografia>{intl.formatMessage({ defaultMessage: "Anexos:" })}</Tipografia>
      {anexos.map(elem => (
        <div
          key={elem.cid}
          className={classes.root}
          onClick={somenteLeitura ? null : () => handleDownload(elem.base64Image, elem.name)}
          style={{ cursor: somenteLeitura ? "default" : "pointer" }}
        >
          <Tipografia
            url={modoTela ? "#" : elem.url}
            urlExterna={!modoTela}
            tipo="notaLegendas"
            cor="darkPrimaryText"
            className={classes.textoAnexo}
          >
            {getNomeAnexo(elem.name, elem.size)}
          </Tipografia>
        </div>
      ))}
    </div>
  );
}

ExibicaoAnexos.propTypes = {
  classes: PropTypes.object,
  anexos: PropTypes.array.isRequired,
  modoTela: PropTypes.bool,
  somenteLeitura: PropTypes.bool,
};

export default injectSheet(styles)(ExibicaoAnexos);
